import React, { useEffect } from "react";
import { useUserPermissions, hasPermission } from "./permissions";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ProtectedRoute = ({ element: Component, permissions, ...rest }) => {
  const userPermissions = useUserPermissions();
  const hasAccess = hasPermission(userPermissions, permissions);

  useEffect(
    () => {
      if (!hasAccess) {
        toast.error("You do not have permission to view this page.");
      }
    },
    [hasAccess]
  );

  return hasAccess ? <Component {...rest} /> : null;
};

export default ProtectedRoute;
